<script>
const { VUE_APP_API_HOST } = process.env

// Liens courts mws.li (feature beta url_shortener) : création à la volée depuis le post creator (POST /links).
// Le raccourcissement direct d'une sélection / de l'URL d'aperçu passe par utils/composerShortLinks.js (cache de session).
export default {
  methods: {
    // source 'composer' par défaut : lien générique du post creator, re-décliné par page/réseau/type à la publication
    createShortLink(body, source = 'composer') {
      return this.$http
        .post(`${VUE_APP_API_HOST}/links`, { ...body, source }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => res, err => err)
    },

    // Message traduit d'une réponse en erreur de l'API /links (400/403/429), générique sinon
    shortLinkErrorMessage(res) {
      const known = {
        400: 'dash.error.short_link_invalid_url',
        403: 'dash.error.beta_feature_disabled',
        429: 'dash.error.short_link_quota_exceeded'
      }
      const key = (res && res.body && typeof res.body.error === 'string' && res.body.error.startsWith('dash.error.short_link'))
        ? res.body.error
        : known[res && res.status]
      return this.$t(key || 'dash.links.error.generic')
    }
  }
}
</script>
